"use client";

import { useEffect, useRef, useState } from "react";

// Renders its children only once the wrapper comes near the viewport. Use it
// around below-the-fold client components (loaded with dynamic(..., { ssr: false })
// and no `loading` fallback) so their JS and hydration are skipped on first load.
// Not for content that must be in the server HTML for SEO.
const LazyOnView = ({ children, rootMargin = "600px 0px", className, min_height }) => {
    const ref = useRef(null);
    const [visible, set_visible] = useState(false);

    useEffect(() => {
        if (visible) return;
        const node = ref.current;
        if (!node || !("IntersectionObserver" in window)) {
            set_visible(true);
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((e) => e.isIntersecting)) {
                    set_visible(true);
                    observer.disconnect();
                }
            },
            { rootMargin }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [visible, rootMargin]);

    return (
        <div ref={ref} className={className} style={!visible && min_height ? { minHeight: min_height } : undefined}>
            {visible ? children : null}
        </div>
    );
};

export default LazyOnView;
